import globalCache from "./global-cache";
import globalEnum from "./global-enum";
import menuConfig from "./menu-config";
import routes from "./routes";

export default {
  // 页面名称
  pageName: "index",
  // 全局缓存
  globalCache,
  // 全局枚举
  globalEnum,
  // token在Cookie中存储的天数，默认1天
  cookieExpires: 1,
  // 是否使用国际化，默认为false
  useI18n: true,
  // 静态路由
  routes,
  // 路由模式（生产环境用hash避免刷新404）
  routerMode: process.env.NODE_ENV === "production" ? "hash" : "history",
  // 基路由
  routerBase: "/",
  // 动态路由
  menuConfig,
  // api请求基础路径
  baseURL: process.env.VUE_APP_SERVER,
  // 默认打开的首页的路由name值，默认为home
  homeName: "home",
  // 产品target
  target: process.env.VUE_APP_TARGET,
  // axios相关配置
  axios: {
    // 路由相关
    route: {
      // 动态路由参数
      params: {
        tenant: "maya",
      },
    },
  },
  // oss
  uploadUrl: "api/sys/oss/upload",
  // 高德地图
  amap: {
    key: "8511d58238a59ca2ee97df9c0fb03063",
    version: "1.4.14",
    plugins: [],
  },
  // 图标设置
  icon: {
    fontClass: "iconfont",
    baseType: "iconfont",
  },
  // wx配置信息
  wx: {
    appid: "wx8522f4d8c0bbd766",
  },
  // 插件配置
  plugins: {
    // 'amap': true,
    "axios-hook": true,
    "identity-auth": true,
    ivux: true,
    "less-vars": true,
    "module-app": true,
    "module-user": true,
    "vue-size-detector": true,
    "vux-alive-tab": true,
    "vux-data-cache": true,
    "vux-dict-manager": true,
    "vux-enum-manager": true,
    "vux-resource": true,
    "vue-flexible": {
      designWidth: 1920,
      designHeight: 1080,
      fit: "contain",
    },
  },
  upload: {
    //图片后缀名
    imgSuffix: ["bmp", "jpg", "jpeg", "png", "gif", "webp", "svg"],
  },
};
